export class InvalidAuthIdentifierError extends Error {
	static readonly NAME = 'InvalidAuthIdentifierError';

	constructor(email: string) {
		super(`Auth identifier is invalid ${email}`);

		this.name = InvalidAuthIdentifierError.NAME;
	}
}
